import { render, staticRenderFns } from "./Dashboardchart.vue?vue&type=template&id=1dd284e4&"
import script from "./Dashboardchart.vue?vue&type=script&lang=js&"
export * from "./Dashboardchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports